import React, { Component } from 'react';
import moment from 'moment';

import { Lens as CircleIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

import { IconButton, Tooltip, Zoom } from '@mui/material';

import Constants from '../../../../common/constants/Constants';
import UsersAccounts from './UsersAccounts';
import Loading from '../../../../common/components/Loading/Loading';
import {
  getUsersAccounts,
  getRoles,
  getUserPermissions,
  createNewUser,
  updateUser,
  deleteUser,
} from './UsersAccounts.actions';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import { connect } from 'react-redux';
import Store from '../../../../redux/Store';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';
import ConfirmationDialog from '../../../../common/components/ConfirmationDialog/ConfirmationDialog';

class UsersAccountsContainer extends Component {
  constructor(props) {
    super();

    this.selectedUserTemplate = {
      UserEntityId: null,
      Username: '',
      Email: '',
      IsLoggedIn: false,
      Name: '',
      AccountExpirationPeriod: props.AccountExpirationPeriodFromSettings,
      AccountCreationTime: moment(),
      AccountExpirationDate: moment()
        .add(props.AccountExpirationPeriodFromSettings, 'days')
        .startOf('day')
        .format('YYYY-MM-DDTHH:mm:ss'),
      LogInTime: '',
      LastActivityTime: '',
      IsAccountEnabled: true,
      RoleEntity: { RoleEntityId: null, Name: '' },
      RoleEntityId: null,
      Permissions: [],
      UsernameErrorMessage: '',
      EmailErrorMessage: '',
      AccountExpirationErrorMessage: '',
    };

    this.dialogTemplate = { show: false, title: '', cancel: () => {}, action: () => {} };

    const iconStyle = {};

    this.state = {
      showDialog: Object.assign({}, this.dialogTemplate),
      selectedUser: Object.assign({}, this.selectedUserTemplate),
      roles: [],
      userPermissions: [],
      data: [],
      isFetching: true,
      isSaving: false,
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
      columnsConfig: [
        {
          name: 'Logged in',
          key: 'IsLoggedIn',
          type: 'markup',
          markup: (el, col, elIndex, colIndex) => {
            var style = {
              width: '.75rem',
              height: '.75rem',
              marginTop: '5px',
              color:
                isNaN(Date.parse(el.LastActivityTime)) || !moment(el.LastActivityTime).isValid()
                  ? Constants.COLORS.ERROR
                  : el.IsLoggedIn &&
                    moment(
                      moment
                        .utc(el.LastActivityTime)
                        .add(Constants.B2C_UsersOfflinePeriod, 'minutes')
                    ).isAfter()
                  ? Constants.COLORS.SUCCESS
                  : Constants.COLORS.ERROR,
            };
            return <CircleIcon key={1} style={style} fill={style.color} />;
          },
          style: { width: '8rem', marginTop: '6px' },
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Enabled',
          type: 'boolean',
          key: 'IsAccountEnabled',
          style: { width: '5rem' },
          visible: false,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Role',
          key: 'Name',
          type: 'string',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Username',
          key: 'Username',
          type: 'string',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Email',
          key: 'Email',
          type: 'string',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Login time',
          key: 'LogInTime',
          type: 'datetime',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Creation time',
          key: 'AccountCreationTime',
          type: 'datetime',
          visible: false,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Release authority',
          key: 'ReleaseAuthority',
          type: 'string',
          visible: false,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Actions',
          key: 'Actions',
          type: 'markup',
          markup: (el, col, elIndex, colIndex) => {
            return (
              <div>
                <PermissionsCheck permission={PermissionsEnum.EDIT_USERS}>
                  {this.props.LoggedInUserRoleId === Constants.Roles.Admin ||
                  this.props.LoggedInUserRoleId > el.RoleEntity.RoleEntityId ? (
                    <Tooltip disableInteractive TransitionComponent={Zoom} title="Edit">
                      <IconButton
                        size="large"
                        key={1}
                        onClick={() => {
                          return this._onClickEdit(el);
                        }}
                        data-qa="qa-edit"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </PermissionsCheck>
                <PermissionsCheck permission={PermissionsEnum.EDIT_USERS}>
                  {(this.props.LoggedInUserRoleId === Constants.Roles.Admin &&
                    this.props.LoggedInUserId != el.UserEntityId) ||
                  this.props.LoggedInUserRoleId > el.RoleEntity.RoleEntityId ? (
                    <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                      <IconButton
                        size="large"
                        key={2}
                        onClick={() => {
                          return this._onClickDelete(el);
                        }}
                        data-qa="qa-delete"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </PermissionsCheck>
              </div>
            );
          },
          style: { width: '10rem' },
          visible: true,
          filterable: false,
          sortable: false,
        },
      ],
    };
  }

  _mapUserProperties = (userList) => {
    if (userList == null) {
      return [];
    }

    const data = userList.map((el) => {
      let releaseAuthority =
        el.User.Permissions.find((p) => p.Name === PermissionsEnum.RELEASE_AUTHORITY) !== undefined
          ? 'true'
          : 'false';

      let newData = Object.assign({}, el, {
        UserEntityId: el.User.UserEntityId,
        Username: el.User.Username,
        Email: el.User.Email,
        IsLoggedIn: el.User.IsLoggedIn,
        Name: el.User.RoleEntity.Name,
        AccountExpirationDate: el.User.AccountExpirationDate,
        AccountCreationTime: el.User.AccountCreationTime,
        UnformattedAccountCreationTime: el.User.AccountCreationTime,
        LogInTime: el.User.LogInTime,
        LastActivityTime: el.User.LastActivityTime,
        IsAccountEnabled: el.User.IsAccountEnabled,
        RoleEntity: el.User.RoleEntity,
        RoleEntityId: el.User.RoleEntity.RoleEntityId,
        Permissions: el.User.Permissions,
        ReleaseAuthority: releaseAuthority,
        UsernameErrorMessage: '',
        EmailErrorMessage: '',
        AccountExpirationErrorMessage: '',
      });

      if (newData.LogInTime === null) {
        //if the user hasn't logged in yet, then display a message
        newData.LogInTime = 'No login data';
      } else {
        newData.LogInTime = el.User.LogInTime;
      }

      delete newData.User;
      return newData;
    });

    return data;
  };

  componentDidMount() {
    let data = [];
    let roles = null;
    let userPermissions = null;

    getUsersAccounts()
      .then((res) => {
        data = this._mapUserProperties(res.body);
        return getRoles();
      })
      .then((res) => {
        roles = res.body;
        return getUserPermissions();
      })
      .then((res) => {
        userPermissions = res.body;
        this.setState({ roles, userPermissions, data, isFetching: false });
      })
      .catch((err) => this.setState({ isFetching: false }));
  }

  _onClickEdit = (userToEdit) => {
    this.setState({
      selectedUser: userToEdit,
      showDialog: {
        show: true,
        title: `Edit user: ${userToEdit.Username}`,
        action: this._handleSaveUser,
        cancel: this._handleClose,
      },
    });
  };

  _onClickDelete = (userToDelete) => {
    this.setState({
      messageToConfirm: `Are you sure you want to delete user "${userToDelete.Username}"?`,
      showConfirmDialog: {
        title: `Delete user ${userToDelete.Username}`,
        show: true,
        action: () => this._onConfirmDeleteUser(userToDelete),
        cancel: this._onCancelDeleteUser,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmDeleteUser = (userToDelete) => {
    if (userToDelete) {
      this.setState({ showConfirmDialog: { disableMainAction: true, show: false } });

      deleteUser(userToDelete.UserEntityId)
        .then((res) => getUsersAccounts())
        .then((res) => {
          // Parse results - tweak dates
          const data = this._mapUserProperties(res.body);
          this.setState({
            data,
            messageToConfirm: '',
            showConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
          });
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
              message: 'Successfully deleted.',
            })
          );
        })
        .catch((err) => {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message: err.response.body.Message,
            })
          );
        });
    }
  };

  _onCancelDeleteUser = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
      },
    });
  };

  _openAddUser = (userData) => {
    //set the default selected role to FSE
    this.selectedUserTemplate.RoleEntity = this.state.roles.find((val) => val.Name === 'FSE');
    this.selectedUserTemplate.RoleEntityId = this.selectedUserTemplate.RoleEntity.RoleEntityId;

    this.setState({
      showDialog: {
        show: true,
        title: 'Add a new user',
        action: this._handleSaveUser,
        cancel: this._handleClose,
      },
      selectedUser: Object.assign({}, this.selectedUserTemplate),
    });
  };

  _setUserPermissions = (permissions) => {
    let changedSelectedUser = this.state.selectedUser;
    changedSelectedUser.Permissions = permissions;

    this.setState({ selectedUser: Object.assign({}, changedSelectedUser) });
  };

  _handleClose = () => {
    this.setState({
      showDialog: Object.assign({}, this.dialogTemplate),
    });
  };

  _handleSaveUser = (event) => {
    if (
      this.state.selectedUser.Username === '' ||
      this.state.selectedUser.Email === '' ||
      this.state.selectedUser.EmailErrorMessage !== '' ||
      this.state.selectedUser.UsernameErrorMessage !== '' ||
      this.state.selectedUser.AccountExpirationErrorMessage !== '' ||
      this.state.selectedUser.AccountExpirationPeriod === ''
    ) {
      Store.dispatch(
        showSnackbar({
          type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
          message: 'Fill out all the fields or correct the entered values.',
        })
      );
    } else {
      let saveObject = {
        User: {
          UserEntityId: this.state.selectedUser.UserEntityId,
          Username: this.state.selectedUser.Username,
          Email: this.state.selectedUser.Email,
          IsAccountEnabled: this.state.selectedUser.IsAccountEnabled,
          RoleEntityId: this.state.selectedUser.RoleEntityId,
          Permissions: this.state.selectedUser.Permissions,
          AccountCreationTime: moment(),
          AccountExpirationDate: this.state.selectedUser.AccountExpirationDate,
        },
      };

      this.setState({ isSaving: true });

      if (saveObject.User.UserEntityId == null) {
        createNewUser(saveObject)
          .then((res) => {
            Store.dispatch(
              showSnackbar({
                type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
                message: 'User created successfully.',
              })
            );
            return getUsersAccounts();
          })
          .then((res) => {
            // Parse results - tweak dates
            const data = this._mapUserProperties(res.body);
            this.setState({
              data,
              isSaving: false,
              showDialog: Object.assign({}, this.dialogTemplate),
              selectedUser: Object.assign({}, this.selectedUserTemplate),
            });
          })
          .catch((err) => {
            this.setState({ isSaving: false });
            Store.dispatch(
              showSnackbar({
                type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
                message: err.response.body.Message,
              })
            );
          });
      } else {
        updateUser(saveObject)
          .then((res) => {
            Store.dispatch(
              showSnackbar({
                type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
                message: 'User updated successfully.',
              })
            );
            return getUsersAccounts();
          })
          .then((res) => {
            const data = this._mapUserProperties(res.body);
            this.setState({
              data,
              isSaving: false,
              showDialog: Object.assign({}, this.dialogTemplate),
            });
          })
          .catch((err) => {
            this.setState({ isSaving: false });

            Store.dispatch(
              showSnackbar({
                type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
                message: err.response.body.Message,
              })
            );
          });
      }
    }
  };

  render() {
    return (
      <Loading condition={this.state.isFetching}>
        <div>
          <ConfirmationDialog
            onClickCancel={this.state.showConfirmDialog.cancel}
            onClickMainAction={this.state.showConfirmDialog.action}
            open={this.state.showConfirmDialog.show}
            messageToConfirm={this.state.messageToConfirm}
            title={this.state.showConfirmDialog.title}
            mainActionLabel={this.state.showConfirmDialog.mainActionLabel}
            disableMainAction={this.state.showConfirmDialog.disableMainAction}
          />
          <UsersAccounts
            data={this.state.data}
            columns={this.state.columnsConfig}
            openAddUser={this._openAddUser}
            showDialog={this.state.showDialog}
            selectedUser={this.state.selectedUser}
            roles={this.state.roles}
            userPermissions={this.state.userPermissions}
            setUserPermissions={this._setUserPermissions}
            isSaving={this.state.isSaving}
          />
        </div>
      </Loading>
    );
  }
}

const mapStateToProps = (state) => ({
  AccountExpirationPeriodFromSettings: state.user.Settings.AccountExpiration,
  LoggedInUserRoleId: state.user.User.RoleId,
  LoggedInUserId: state.user.User.UserId,
});

export default withRouter(connect(mapStateToProps, null)(UsersAccountsContainer));
